import { GOOGLE_LOGIN_CLIENT_ID } from '@src/services/.env.js'

const normalizeRedirectUri = (uri) => {
  try {
    const url = new URL(uri)
    let normalized = `${url.origin}${url.pathname}`
    if (normalized.endsWith('/') && normalized !== url.origin + '/') {
      normalized = normalized.slice(0, -1)
    }
    return normalized
  } catch (e) {
    return uri
  }
}

export const buildGoogleAuthUrl = (redirectUri, subDomain, provider) => {
  const stateData = {
    sub_domain: subDomain,
    provider: provider,
  }
  const state = btoa(JSON.stringify(stateData))
  const normalizedRedirectUri = normalizeRedirectUri(redirectUri)

  const params = new URLSearchParams({
    client_id: GOOGLE_LOGIN_CLIENT_ID,
    redirect_uri: normalizedRedirectUri,
    response_type: 'token',
    scope: 'openid email profile',
    include_granted_scopes: 'true',
    state: state,
    prompt: 'select_account',
  })
  return `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`
}

export const redirectToGoogleLogin = (redirectUri, subDomain, provider) => {
  const googleAuthUrl = buildGoogleAuthUrl(redirectUri, subDomain, provider)
  window.location.href = googleAuthUrl
}

export const handleGoogleOAuthCallback = (hash) => {
  const hashParams = new URLSearchParams(hash)
  const accessToken = hashParams.get('access_token')
  const error = hashParams.get('error')
  const errorDescription = hashParams.get('error_description')
  const state = hashParams.get('state')

  if (error) {
    let errorMessage = 'Google authentication failed'

    if (error === 'access_denied') {
      errorMessage =
        'You denied access to your Google account. Please try again and grant the necessary permissions.'
    } else if (error === 'invalid_request') {
      errorMessage = 'Google login configuration error. Please contact support.'
    } else if (error === 'unauthorized_client') {
      errorMessage = 'Google login is not properly configured. Please contact support.'
    } else if (errorDescription) {
      errorMessage = `Google authentication failed: ${errorDescription}`
    } else {
      errorMessage = `Google authentication failed: ${error}`
    }

    return {
      error: true,
      errorMessage,
    }
  }

  if (accessToken && state) {
    try {
      const stateData = JSON.parse(atob(state))
      return {
        error: false,
        access_token: accessToken,
        provider: stateData.provider,
        sub_domain: stateData.sub_domain,
      }
    } catch (e) {
      return {
        error: true,
        errorMessage: 'Failed to process Google authentication response',
      }
    }
  }

  return null
}

export const hasHandledGoogleCallback = () => {
  return sessionStorage.getItem('googleOAuthHandled') === 'true'
}

export const setGoogleOAuthHandled = () => {
  sessionStorage.setItem('googleOAuthHandled', 'true')
}

export const clearGoogleOAuthHandled = () => {
  sessionStorage.removeItem('googleOAuthHandled')
}
